import { getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledFooterContainer = styled.div`
  padding: 0 ${getSpacing('xxl')};
`;
